import {
  CREATE_PROGRAM_DETAILS_REQUEST,
  CREATE_PROGRAM_DETAILS_SUCCESS,
  CREATE_PROGRAM_DETAILS_FAILED,
  CREATE_PROGRAM_COMMITMENTS_SUCCESS,
  CREATE_PROGRAM_COMMITMENTS_FAILED,
  CREATE_PROGRAM_COMMITMENTS_REQUEST,
  UPLOAD_SANDBOX_SUCCESS,
  UPLOAD_SANDBOX_FAILED,
  UPLOAD_SANDBOX_REQUEST,
  CLEAR_PROGRAM_SUCCESS,
  GET_PROGRAM_PUBLISH_REQUEST,
  GET_PROGRAM_PUBLISH_FAILED,
  GET_PROGRAM_PUBLISH_SUCCESS,
  UPDATE_PROGRAM_STATUS_REQUEST,
  UPDATE_PROGRAM_STATUS_SUCCESS,
  UPDATE_PROGRAM_STATUS_FAILED,
  UPDATE_PROGRAM_DETAILS_REQUEST,
  UPDATE_PROGRAM_DETAILS_SUCCESS,
  UPDATE_PROGRAM_DETAILS_FAILED,
  UPDATE_PROGRAM_DAY_DETAILS_REQUEST,
  UPDATE_PROGRAM_DAY_DETAILS_FAILED,
  UPDATE_PROGRAM_DAY_DETAILS_SUCCESS,
  SEARCH_PROGRAM_REQUEST,
  SEARCH_PROGRAM_SUCCESS,
  SEARCH_PROGRAM_FAILED,
  UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST,
  UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS,
  UPDATE_PROGRAM_PUBLISH_STATUS_FAILED,
  REMOVE_PROGRAM_FAILED,
  REMOVE_PROGRAM_SUCCESS,
  REMOVE_PROGRAM_REQUEST,
  REMOVE_COMMITMENT_SUCCESS,
  REMOVE_COMMITMENT_FAILED,
  REMOVE_COMMITMENT_REQUEST,
  SAVE_SINGLE_COMMITMENT_DETAILS,
  GET_EXPLORE_CONTENT_REQUEST,
  GET_EXPLORE_CONTENT_SUCCESS,
  GET_EXPLORE_CONTENT_FAILED,
  GET_PROGRAM_CATEGORY_SUCCESS,
  GET_PROGRAM_CATEGORY_FAILED,
  GET_PROGRAM_CATEGORY_REQUEST,

} from "../Actions/ProgramAction";

const UsersInitialState = {
  loading: false,
  updateLoading: false,
  success: false,
  errors: {},
  usersPerPage: 10,
  currentPage: 1,
  totalCount: 0,
  sandboxList: [],
  draftsList: [],
  createProgram: {
    programDetails: [],
    programCommitments: [],
  },
  getProgramDetails: [],
  isEdit: false,
  ProgramType: "",
  programList: [],
  contentList: [],
  categoryList: [],
  sandbox: false,
};

export const ProgramReducer = (state = UsersInitialState, action) => {
  switch (action.type) {
   
    case UPLOAD_SANDBOX_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        sandbox: false,
      };
    case UPLOAD_SANDBOX_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        sandbox: false,
      };
    case UPLOAD_SANDBOX_SUCCESS:
      return {
        ...state,
        loading: false,
        createProgram: {
          programCommitments: [],
          programDetails: [],
        },
        getProgramDetails: [],
        totalCount: 0,
        isEdit: false,
        sandbox: true,
        success: action.payload.success,
      };

    case CREATE_PROGRAM_DETAILS_SUCCESS:
      return {
        ...state,
        createProgram: {
          programDetails: [action.payload],
        },
        loading: false,
      };
    case CREATE_PROGRAM_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROGRAM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
      };

    case CREATE_PROGRAM_COMMITMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CREATE_PROGRAM_COMMITMENTS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_PROGRAM_COMMITMENTS_SUCCESS:
      const checkCommitExist = state.createProgram.programCommitments?.find(
        (data) => data?.day === action.payload.day
      );
      if (!!checkCommitExist) {
        const tempProgramCommits = [
          ...(state.createProgram.programCommitments || []),
        ];

        const findCommitIndex = tempProgramCommits?.findIndex(
          (data) => action.payload.day === data.day
        );

        tempProgramCommits?.splice(findCommitIndex, 1, action.payload);

        return {
          ...state,
          createProgram: {
            ...state.createProgram,
            programCommitments: [...tempProgramCommits],
          },
          loading: false,
        };
      } else {
        return {
          ...state,
          createProgram: {
            ...state.createProgram,
            programCommitments: [
              ...(state.createProgram.programCommitments || []),
              action.payload,
            ],
          },
          loading: false,
        };
      }

    case UPDATE_PROGRAM_DAY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PROGRAM_DAY_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PROGRAM_DAY_DETAILS_SUCCESS:
      return {
        ...state,
        getProgramDetails: action.payload,
        loading: false,
      };
    case CLEAR_PROGRAM_SUCCESS: {
      return {
        ...state,
        loading: false,
        createProgram: {
          programCommitments: [],
          programDetails: [],
        },
        getProgramDetails: [],
        totalCount: 0,
        isEdit: false,
        success: false,
        sandbox: false,
      };
    }
    case GET_PROGRAM_PUBLISH_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case GET_PROGRAM_PUBLISH_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case GET_PROGRAM_PUBLISH_SUCCESS:
      return {
        ...state,
        loading: false,
        getProgramDetails: action?.payload,
        totalCount: action?.payload?.total,
        isEdit: true,
        success: true,
      };
    case UPDATE_PROGRAM_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROGRAM_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        programList:
          state?.ProgramType === "publish"
            ? state?.programList?.map((item) =>
                item?.id === action?.payload?.id ? action?.payload : item
              )
            : state?.ProgramType === "sandbox"
            ? state?.programList?.map((item) =>
                item?.id === action?.payload?.id ? action?.payload : item
              )
            : state?.ProgramType === "draft"
            ? state?.programList?.map((item) =>
                item?.id === action?.payload?.id ? action?.payload : item
              )
            : state?.programList?.programList,
      };

    case UPDATE_PROGRAM_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PROGRAM_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROGRAM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        totalCount: action?.payload?.total,

        createProgram: {
          programDetails: !state.isEdit ? [action.payload] : [],
          programCommitments: !state.isEdit ? action?.payload?.commitments : [],
        },
        getProgramDetails: state.isEdit ? action?.payload : "",
      };
    case UPDATE_PROGRAM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_PROGRAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_PROGRAM_SUCCESS:
      return {
        ...state,
        ProgramType: action?.payload?.type,
        programList: action?.payload?.program_list,
        totalCount: action?.payload?.total,
        loading: false,
      };
    case SEARCH_PROGRAM_FAILED:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        programList:
          state?.ProgramType === "publish"
            ? state?.programList?.filter(
                (item) => item?.id !== action?.payload?.id
              )
            : state?.ProgramType === "sandbox"
            ? state?.programList?.filter(
                (item) => item?.id !== action?.payload?.id
              )
            : state?.ProgramType === "draft"
            ? state?.programList?.filter(
                (item) => item?.id !== action?.payload?.id
              )
            : state?.programList,
      };
    case UPDATE_PROGRAM_PUBLISH_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REMOVE_PROGRAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_PROGRAM_SUCCESS:
      return {
        ...state,
        programList:
          state?.ProgramType === "publish"
            ? state?.programList?.filter((item) => item?.id !== action?.payload)
            : state?.ProgramType === "sandbox"
            ? state?.programList?.filter((item) => item?.id !== action?.payload)
            : state?.ProgramType === "draft"
            ? state?.programList?.filter((item) => item?.id !== action?.payload)
            : state?.programList,
        loading: false,
      };
    case REMOVE_PROGRAM_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REMOVE_COMMITMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_COMMITMENT_SUCCESS:
      const { c_id, cd_id, type } = action.payload;
      if (type === "UPDATE") {
        let updatedTempCommitArr = [];
        let tempCommitArr = [];

        state?.getProgramDetails?.commitments?.map((item, index) =>
          item?.id === c_id
            ? (updatedTempCommitArr = item?.commitment_details)
            : ""
        );
        updatedTempCommitArr?.map((item, index) =>
          item?.id === cd_id ? updatedTempCommitArr.splice(index, 1) : ""
        );
        tempCommitArr = state?.getProgramDetails?.commitments?.map(
          (item, index) => item
        );
        tempCommitArr?.forEach((item, index) => {
          if (item?.id === c_id) {
            return { ...item, commitment_details: updatedTempCommitArr };
          }
        });

        return {
          ...state,
          getProgramDetails: {
            ...state.getProgramDetails,
            commitments: tempCommitArr,
          },
          loading: false,
        };
      } else if (type === "CREATE") {
        let tempComitDetailsArr = [];
        let tempProgramCommitments = [];
        state?.createProgram?.programCommitments?.map((item, index) =>
          item?.id === c_id
            ? (tempComitDetailsArr = item?.commitment_details)
            : ""
        );
        tempComitDetailsArr?.map((item, index) =>
          item?.id === cd_id ? tempComitDetailsArr.splice(index, 1) : ""
        );
        tempProgramCommitments = state?.createProgram?.programCommitments?.map(
          (item, index) => item
        );
        tempProgramCommitments?.map((item, index) => {
          if (item?.id === c_id) {
            return { ...item, commitment_details: tempComitDetailsArr };
          }
        });
        return {
          ...state,
          createProgram: {
            ...state.createProgram,
            programCommitments: tempProgramCommitments,
          },
          loading: false,
        };
      } else {
        return {
          ...state,
          loading: false,
        };
      }
    case REMOVE_COMMITMENT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SAVE_SINGLE_COMMITMENT_DETAILS:
      let tempCommit = [];
      let { commitments_details } = action.payload;
      commitments_details = commitments_details?.map((item) => {
        if (item.id === action.payload.cd_id) {
          return { ...item, is_change: true };
        } else {
          return item;
        }
      });

      tempCommit = state?.getProgramDetails?.commitments?.map((item, index) => {
        if (item?.id === action.payload.c_id) {
          return { ...item, commitment_details: commitments_details };
        } else {
          return item;
        }
      });
      return {
        ...state,
        loading: false,
        getProgramDetails: {
          ...state.getProgramDetails,
          commitments: tempCommit,
        },
      };
    case GET_EXPLORE_CONTENT_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case GET_EXPLORE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        contentList: action.payload,
      };

    case GET_EXPLORE_CONTENT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case GET_PROGRAM_CATEGORY_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case GET_PROGRAM_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryList: action.payload,
      };
    case GET_PROGRAM_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
